<template>
  <div class="max-w-sm mx-auto">
    <form
      class="bg-white shadow-lg rounded px-4 pt-4 pb-8 m-2 border border-gray-200"
      @submit.prevent="setNewTaxDay"
    >
      <p class="text-center font-display text-xl text-pink-400 mb-6">Set tax day</p>
      <p class="text-center my-3">Current tax day is: {{ taxDay }}</p>
      <div class="mb-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="day">Day</label>
        <input
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="day"
          @blur="formatDay"
          type="number"
          v-model="day"
        />
        <small class="text-red-400 text-xs" v-if="dayError">{{ dayError }}</small>
      </div>
      <div class="mb-6">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="month">Month</label>
        <select
          class="shadow border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
          id="month"
          @change="validateMonth"
          v-model="month"
        >
          <option value>- Please choose -</option>
          <option v-for="month in months" :key="month.value" :value="month.value">{{ month.desc }}</option>
        </select>
        <small class="text-red-400 text-xs" v-if="monthError">{{ monthError }}</small>
      </div>
      <div class="text-right">
        <button
          class="bg-teal-400 hover:bg-teal-500 text-white py-2 px-4 rounded focus:outline-none"
          type="submit"
        >Set new tax day</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "tax-day",
  data() {
    return {
      day: "",
      month: "",
      tax: "",
      dayError: "",
      monthError: "",
      months: [
        { value: "01", desc: "January" },
        { value: "02", desc: "February" },
        { value: "03", desc: "March" },
        { value: "04", desc: "April" },
        { value: "05", desc: "May" },
        { value: "06", desc: "June" },
        { value: "07", desc: "July" },
        { value: "08", desc: "August" },
        { value: "09", desc: "September" },
        { value: "10", desc: "October" },
        { value: "11", desc: "November" },
        { value: "12", desc: "December" }
      ]
    };
  },
  methods: {
    setNewTaxDay() {
      let checkDay = this.validateDay();
      let checkMonth = this.validateMonth();

      if (!checkDay || !checkMonth) {
        return false;
      }

      let payload = {
        id: this.userSettings.settingsId,
        userId: this.userSettings.userId,
        taxDay: `${this.month}-${this.day}`
      };

      this.$store.dispatch("setNewTaxDay", payload);
    },
    validateDay() {
      if (!this.day) {
        this.dayError = "Day is required.";
        return false;
      }

      if (parseInt(this.day) < 1 || parseInt(this.day) > 31) {
        this.dayError = "Day can't be less than 01 and more than 31.";
        return false;
      }

      this.dayError = "";

      return true;
    },
    validateMonth() {
      if (!this.month) {
        this.monthError = "Month is required";
        return false;
      }

      this.monthError = "";

      return true;
    },
    formatDay() {
      if (this.day.toString().length === 1) {
        if (!this.day.startsWith("0")) {
          this.day = "0" + this.day.toString();
        }
      }
      this.validateDay();
    }
  },
  computed: {
    taxDay() {
      let d = this.$store.getters.settings.taxDay;
      let arr = d.split("-");
      let month = this.months.find(m => m.value === arr[0]).desc;
      return `${arr[1]} ${month}`;
    },
    userSettings() {
      return this.$store.getters.settings;
    }
  },
  mounted() {
    let d = this.$store.getters.settings.taxDay;
    let arr = d.split("-");
    this.day = arr[1];
    this.month = arr[0];
  }
};
</script>

<style lang="scss" scoped>
</style>